import _typeof from 'babel-runtime/helpers/typeof';

import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducer';

var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

export default (function () {
  return createStore(reducer, composeEnhancers(applyMiddleware(thunk)));
});


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/state/create-store.js
// module id = 1863
// module chunks = 1